import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    filename: String
  }

  async downloadImage(event) {
    event.preventDefault()
    
    try {
      // Show loading state
      this.element.disabled = true
      this.element.classList.add("opacity-75")
      
      // Fetch the image and create blob
      const response = await fetch(this.urlValue)
      if (!response.ok) throw new Error("Download failed")
      
      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)
      
      // Create and trigger download
      const link = document.createElement("a")
      link.style.display = "none"
      link.href = blobUrl
      link.download = this.filenameValue || "image.png"
      
      document.body.appendChild(link)
      link.click()
      
      // Cleanup
      window.URL.revokeObjectURL(blobUrl)
      document.body.removeChild(link)
      
      // Reset button state
      this.element.disabled = false
      this.element.classList.remove("opacity-75")
    } catch (error) {
      console.error("Image download failed:", error)
      this.element.disabled = false
      this.element.classList.remove("opacity-75")
    }
  }
} 